"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useInputWidth_1 = require("src/hooks/useInputWidth");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const UnderlineError_1 = tslib_1.__importDefault(require("../errors/UnderlineError"));
const ModifiedNumberField = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const [isTypeError, setIsTypeError] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)(null);
    const inputWidth = (0, useInputWidth_1.useInputWidth)(ref);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { ref: ref, id: props.id || props.name, name: props.name, type: 'text', style: props.style, disabled: props.disabled, onChange: event => {
                    // const value: string = event.target.value.charAt(event.target.value.length - 1) === ',' ? event.target.value.slice(0, -1) + '.' : event.target.value
                    const value = event.target.value.replace(',', '.');
                    const valueToNumber = value === ' ' || value === '-' ? NaN : Number(value + '0');
                    if (!isNaN(valueToNumber)) {
                        if (valueToNumber < 0 && !props.allowedNegative)
                            return setIsTypeError(true);
                        if (isTypeError)
                            setIsTypeError(false);
                        props.handleChange(props.name, value);
                    }
                    else {
                        setIsTypeError(true);
                    }
                }, value: props.value || '', autoComplete: props.autocomplete || 'off', className: (props.className || `form-control${props.small ? ' form-control-sm' : ''}`) + (props.error ? ' is-invalid' : ''), placeholder: props.placeholder, min: props.min, max: props.max }), (0, jsx_runtime_1.jsx)(UnderlineError_1.default, { errorMessage: props.error || (isTypeError ? translate('only_positive_numbers', 'მხოლოდ დადებითი რიცხვი') : ''), elementWidth: inputWidth.refWidth })] }));
};
exports.default = ModifiedNumberField;
